import { convertMembershipOfferComponents } from './m-membership';
import { MembershipLevelOffer } from '@aaa/emember/store-price-offers';
import { MembershipOffering } from '@aaa/interface-joinRenew-membership-membershipM';

export function getMembershipOffering(offerings: MembershipOffering[]) {
  return offerings.reduce((acc, offering) => {
    if (offering?.$?.membershipType) {
      const prop = String(offering?.$?.membershipType);
      acc[prop] = convertMembershipOfferComponents(offering);
    }
    return acc;
  }, {} as MembershipLevelOffer);
}
